import { render, staticRenderFns } from "./customerIndex.vue?vue&type=template&id=0a2647ba&scoped=true&"
import script from "./customerIndex.vue?vue&type=script&lang=js&"
export * from "./customerIndex.vue?vue&type=script&lang=js&"
import style0 from "./customerIndex.vue?vue&type=style&index=0&id=0a2647ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2647ba",
  null
  
)

export default component.exports